
window.addEventListener('load', () => {

    /* This script supports IE9+ */
    (function() {
    /* Opening modal window function */
    function openModal() {
        /* Get trigger element */
        var modalTrigger = document.getElementsByClassName('our-team-modal');

        /* Set onclick event handler for all trigger elements */
        for(var i = 0; i < modalTrigger.length; i++) {
            modalTrigger[i].onclick = function() {
                var target = this.getAttribute('data-modal');
                var modalWindow = document.getElementById(target);

                modalWindow.classList ? modalWindow.classList.add('open') : modalWindow.className += ' ' + 'open'; 
            }
        }   
    }

    function closeModal(){
        /* Get close button */
        var closeButton = document.getElementsByClassName('jsModalClose');
        var closeOverlay = document.getElementsByClassName('jsOverlay');

        /* Set onclick event handler for close buttons */
        for(var i = 0; i < closeButton.length; i++) {
            closeButton[i].onclick = function() {
            var modalWindow = this.parentNode.parentNode;

            modalWindow.classList ? modalWindow.classList.remove('open') : modalWindow.className = modalWindow.className.replace(new RegExp('(^|\\b)' + 'open'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            }
        }   

        /* Set onclick event handler for modal overlay */
        for(var i = 0; i < closeOverlay.length; i++) {
            closeOverlay[i].onclick = function() {
            var modalWindow = this.parentNode;

            modalWindow.classList ? modalWindow.classList.remove('open') : modalWindow.className = modalWindow.className.replace(new RegExp('(^|\\b)' + 'open'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            }
        }  

    }

    /* Handling domready event IE9+ */
    function ready(fn) {
        if (document.readyState != 'loading'){
        fn();
        } else {
        document.addEventListener('DOMContentLoaded', fn);
        }
    }

    /* Triggering modal window function after dom ready */
    ready(openModal);
    ready(closeModal);
    }());

	var active_tab = document.querySelector('.bartender_tab_section .bartender_tab-title:first-child');
    active_tab.classList.add("active");

	var active_category = active_tab.getAttribute("data-id");
   
	var category_name = '[data-tab="' + active_category+'"]';
	var items = document.querySelectorAll(category_name);
	items.forEach(item => {
		item.classList.remove("inactive");
	});
    
   
    var all_swipers = document.querySelectorAll('.bartender_swiper');
    setTimeout(function() {
        all_swipers.forEach(item => {
            if(item.getAttribute("data-tab") != active_category){
                item.classList.add("inactive");
            }
        });
    }, 1000);
  
   
	var tab_lists = document.getElementsByClassName("bartender_tab-title");

	var updateBartender = function() {
		var all_tab = document.querySelectorAll('.bartender_tab-title');
		all_tab.forEach(item => {
			item.classList.remove("active");
		});
		this.classList.add("active");

		var all_swipers = document.querySelectorAll('.bartender_swiper')
		all_swipers.forEach(item => {
			item.classList.add("inactive");
		});

		var active_category = this.getAttribute("data-id");
		var category_name = '[data-tab="' + active_category+'"]';
		var items = document.querySelectorAll(category_name);
		items.forEach(item => {
			item.classList.remove("inactive");
		});
	};

	for (var i = 0; i < tab_lists.length; i++) {
		tab_lists[i].addEventListener('click', updateBartender, false);
	}

    // active_tab.click();
     console.log("clicked");
});
window.addEventListener("load", function() {
    console.log('Page is loaded');
});